<aside class="l-sidebar l-flex l-column" [class.is-shown]="ui.mobileOpen()" [attr.dir]="dir">
  <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

  <ng-content></ng-content>

  <app-docpanel></app-docpanel>
</aside>
